import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'configGenerals';
export const configGeneralsActions = makeActions(MODEL_NAME,'id','config-generals');

export const getAllConfigGenerals = configGeneralsActions.getAll;
export const editConfigGenerals = configGeneralsActions.edit;
export const createConfigGenerals = configGeneralsActions.create;
export const getByIdConfigGenerals = configGeneralsActions.getDataById;
